import React from "react";
import OverrideForm from "../common-quote/OverrideForm";
import { FixAndFlipCalculation } from "../../lib/models/short-term/short-term-calculation.model";
import {
  FixAndFlipOverrideOptions,
  FixAndFlipQuote,
} from "../../lib/models/short-term/short-term.model";
import { RentalCalculation } from "../../lib/models/rental/rental-calculation.model";
import {
  RentalOverrideOptions,
  RentalQuote,
} from "../../lib/models/rental/rental.model";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { CalculationType } from "../../state/quote-reducer";

export interface QuoteOverrideContentProps {
  isFnf: boolean;
  calculation: CalculationType;
  quote: FixAndFlipQuote | RentalQuote | null;
  formActionHandler: (action: QuoteFormActions, formValues: any) => void;
  preferredLoanAmt: number | undefined;
}

const QuoteOverrideContent = (props: QuoteOverrideContentProps) => {
  const { quote, isFnf, calculation, formActionHandler, preferredLoanAmt } =
    props;
  return (
    <>
      {isFnf === true ? (
        <OverrideForm
          stfCalc={calculation as FixAndFlipCalculation}
          exceptionPricingOverride={
            quote?.exceptionPricingOverride as FixAndFlipOverrideOptions
          }
          formHandler={formActionHandler}
          totalLoanAmt={
            (calculation as FixAndFlipCalculation)?.LTCCalcOnPurchaseRehab
              ?.loanAmt
          }
        />
      ) : (
        <OverrideForm
          rentalCalc={props.calculation as RentalCalculation}
          exceptionPricingOverride={
            props.quote?.exceptionPricingOverride as RentalOverrideOptions
          }
          formHandler={formActionHandler}
          totalLoanAmt={preferredLoanAmt}
        />
      )}
    </>
  );
};

export default QuoteOverrideContent;
